import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    userPlatform: null,
  },
  mutations: {
    SET_USER(state, value) {
      state.user = value;
    },

    SET_USER_PLATFORM(state, value) {
      state.userPlatform = value;
    }
  },
  actions: {
    setUser({ commit }, payload) {
      commit("SET_USER", payload);
    },

    setUserPlatform({ commit }, payload) {
      commit("SET_USER_PLATFORM", payload);
    },
  }
})
